export default function Contacts() {
  return (
    <div className="container">
      <div className="card my-4 ">
        <div className="row my-4 ">
          <div className="col-lg-1 col-md-2 col-3">
            <i className="bi bi-envelope-at display-6 mx-4"></i>
          </div>
          <div className="col-lg-11 col-md-10 col-9">
            <p className="mb-0">
              Якщо у вас виникли запитання, пропозиції, зауваження або будь-які
              інші побажання, напишіть нам на{" "}
              <span className="fw-bold">justfunc73@proton.me</span>. Ми вдячні
              за ваш внесок у поліпшення нашого сервісу!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
